import { useParams } from 'react-router-dom';

// project imports
import { AuthHeader, ApiUrl } from 'utils/Constants';
import { store } from 'store';
import { SET_MENU_BASIS, SET_MENU_ACCESS, SET_MENU_BADGE } from 'store/actions';

// ==============================|| DASHBOARD DEFAULT - Basis Menu CARD ||============================== //

const getBasisMenu = (basisId, force = true) => {
    const getBasis = async (basisId) => {
        const res = await fetch(`${ApiUrl}/api/basis/${basisId}?user_basis=1&task=1&receipt_task=1&inventory_task=1&cheque_task=1`, {
            method: 'GET',
            headers: AuthHeader
        });
        //console.log(res);
        const response = await res.json();
        const data = response.data;

        // Set menu basis
        store.dispatch({
            type: SET_MENU_BASIS,
            menuBasis: basisId
        });

        // Set menu access
        store.dispatch({
            type: SET_MENU_ACCESS,
            menuAccess: data?.user_bases[0]?.permission?.split(', ')
        });

        // Set menu badges
        store.dispatch({
            type: SET_MENU_BADGE,
            menuBadge: {
                task: data?.task,
                taskTime: data?.taskTime,
                receipt: data?.taskReceipt,
                entry: data?.taskEntry,
                invoice: data?.taskInvoice,
                transfer: data?.taskTransfer,
                production: data?.taskProduction,
                returnIn: data?.taskReturnIn,
                returnOut: data?.taskReturnOut,
                buyOrder: data?.taskBuyOrder,
                cheque: data?.taskCheque
            }
        });
    };

    const data = store.getState()?.customization;
    if (force || !data?.menuBadge || basisId != data?.menuBasis) getBasis(basisId);
};

export default getBasisMenu;
export { getBasisMenu };
